import React from 'react'

const FormContext = React.createContext<{ showLegacyMargin: boolean }>({
  showLegacyMargin: false,
})

export { FormContext }
